import { Container, Tab, Tabs } from "@mui/material";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import useTabs from "src/hooks/useTabs";

import AdminActives from "./AdminActives";
import AdminClients from "./AdminClients";
import AdminEntities from "./AdminEntities";
import AdminTransfers from "./AdminTransfers";

// ----------------------------------------------------------------------

export const Admin = () => {
	const { currentTab, onChangeTab } = useTabs("clients");

	return (
		<Page title='Admin'>
			<Container maxWidth={"xl"}>
				<PageHeader title='Admin' back={false} />
				<Tabs
					allowScrollButtonsMobile
					onChange={onChangeTab}
					scrollButtons='auto'
					sx={{ mt: 2, mb: 2.5 }}
					textColor='primary'
					value={currentTab}
					variant='scrollable'
				>
					<Tab disableRipple label={"Gestión de clientes"} value='clients' />
					<Tab disableRipple label={"Gestión de activos"} value='actives' />
					<Tab disableRipple label={"Entidades"} value='entities' />
					<Tab disableRipple label={"Traspasos"} value='transfers' />
				</Tabs>
				{currentTab === "clients" && <AdminClients />}
				{currentTab === "actives" && <AdminActives />}
				{currentTab === "entities" && <AdminEntities />}
				{currentTab === "transfers" && <AdminTransfers />}
			</Container>
		</Page>
	);
};

export default Admin;
